export const JAPANESE_SOLUTION_CONTENT = {
  1: {
    slug: 'digital-signage-healthcare',
    translation: {
      title: '医療・クリニック・待合室向けデジタルサイネージ',
      description: '病院、クリニック、診療所、待合室の案内やお知らせをAdCastで遠隔管理。Android TVや対応端末を使って患者向け情報を簡単に配信できます。',
      date: '2026年9月5日', datePublished: '2025-10-03', dateModified: '2026-09-05',
      content: `<h2>医療・クリニック向けデジタルサイネージ</h2><p>AdCastを使えば、病院、クリニック、診療所、歯科、動物病院などの待合室や受付画面を一元管理できます。患者や来訪者向けのお知らせ、診療時間、健康情報、注意事項を遠隔から更新できます。</p><h3>待合室の情報をいつでも最新に</h3><p>診療案内、受付時間、休診情報、予防接種、健康情報、院内ルールなどを表示できます。紙の掲示物を交換する代わりに、スマホから更新して画面へ配信できます。</p><h3>複数の画面・施設を一括管理</h3><p>受付、待合室、スタッフエリアなど用途ごとにプレイリストを分けられます。複数拠点でも、接続した画面を一つのAdCastアカウントから管理できます。</p><h3>Android TVで簡単に開始</h3><p>対応するAndroid TVや端末に<strong>AdCast Player</strong>をインストールし、QRコードで接続します。あとは画像、動画、案内コンテンツをプレイリストに追加して配信するだけです。</p><p>公共の画面には患者を特定できる情報や機密情報を表示せず、一般的な案内やコミュニケーション用途で利用してください。</p>`
    }
  },
  2: {
    slug: 'digital-signage-restaurants',
    translation: {
      title: '飲食店向けデジタルサイネージ・デジタルメニューボード',
      description: 'レストラン、カフェ、飲食店のデジタルメニューボードをAdCastで簡単管理。価格、日替わりメニュー、キャンペーンをAndroid TVやFire TVへ遠隔配信できます。',
      date: '2026年9月5日', datePublished: '2025-10-03', dateModified: '2026-09-05',
      content: `<h2>飲食店のデジタルメニューボードをもっと簡単に</h2><p>AdCastなら、レストラン、カフェ、ベーカリー、テイクアウト店のテレビをデジタルメニューボードとして活用できます。メニュー、価格、商品写真、日替わり情報、キャンペーンをスマホから更新できます。</p><h3>価格やメニュー変更をすぐ反映</h3><p>紙のメニューを印刷し直す必要はありません。AdCastで内容を変更し、接続済みの画面へ配信すれば更新できます。</p><h3>時間帯別にメニューを切り替え</h3><p>朝食、ランチ、ディナー、ハッピーアワーなど、時間帯に合わせて異なるプレイリストや広告を表示できます。</p><h3>CanvaからAdCastへ</h3><p>Canvaでメニューデザインを作成し、AdCastへエクスポートして広告やプレイリストに利用できます。</p><img src="/assets/img/solution/coffee_shop2.jpg" alt="飲食店向けデジタルメニューボード" style="width:100%; margin:20px 0;" /><h3>USBやPCなしで更新</h3><p>対応するAndroid TVまたはFire TV端末に<strong>AdCast Player</strong>をインストールして画面を接続すれば、日々の変更はスマホから遠隔で行えます。</p>`
    }
  },
  3: {
    slug: 'digital-signage-gyms',
    translation: {
      title: 'ジム・フィットネス向けデジタルサイネージ',
      description: 'ジムのクラススケジュール、キャンペーン、トレーナー紹介、会員向け情報をデジタルサイネージで表示。AdCastならスマホから遠隔更新できます。',
      date: '2026年9月5日', datePublished: '2025-10-03', dateModified: '2026-09-05',
      content: `<h2>ジム・フィットネス向けデジタルサイネージ</h2><p>受付、トレーニングエリア、スタジオなどの画面に、クラススケジュール、キャンペーン、トレーナー紹介、イベント情報を表示できます。</p><h3>クラス予定や変更をすぐに案内</h3><p>変更が多い情報をスマホから更新して画面へ配信できます。</p><h3>会員向けプロモーション</h3><p>パーソナルトレーニング、追加サービス、キャンペーンなどを館内の画面で告知できます。</p><h3>エリアごとに異なるコンテンツ</h3><p>受付、スタジオ、ウェイトエリアなど、画面ごとまたはグループごとに異なるプレイリストを設定できます。</p><h3>スマホから遠隔管理</h3><p>画像や動画のアップロード、プレイリスト作成、配信、スケジュール変更までAdCastアプリから行えます。</p>`
    }
  },
  4: {
    slug: 'digital-signage-lobby-reception',
    translation: {
      title: 'ロビー・受付・オフィス向けデジタルサイネージ',
      description: 'ロビーや受付のウェルカム画面、案内、イベント、社内情報をAdCastで遠隔管理。オフィスやホテルのデジタルサイネージを簡単に運用できます。',
      date: '2026年9月5日', datePublished: '2025-10-03', dateModified: '2026-09-05',
      content: `<h2>ロビー・受付のデジタルサイネージ</h2><p>オフィス、ホテル、施設の受付画面にウェルカムメッセージ、会社案内、イベント、フロア情報、営業時間などを表示できます。</p><h3>来訪者向け情報を見やすく表示</h3><p>案内図、担当部署、イベント予定、注意事項、サービス情報などを一つの画面でローテーション表示できます。</p><h3>予定に合わせて自動表示</h3><p>イベントや訪問予定に合わせてコンテンツをスケジュールできます。</p><h3>複数拠点を遠隔更新</h3><p>本社、支店、受付、共有スペースなど複数の画面を一つのアカウントから管理できます。</p><h3>既存テレビを活用</h3><p>対応するAndroid TVやFire TV端末にAdCast Playerを入れて接続すれば、既存のテレビを活用できます。</p>`
    }
  },
  5: {
    slug: 'digital-signage-salons',
    translation: {
      title: '美容室・サロン・バーバー向けデジタルサイネージ',
      description: '美容室やバーバーで料金、施術例、キャンペーン、スタッフ紹介、商品をデジタルサイネージ表示。AdCastならスマホから簡単に更新できます。',
      date: '2026年9月5日', datePublished: '2026-04-11', dateModified: '2026-09-05',
      content: `<h2>美容室・サロン向けデジタルサイネージ</h2><p>美容室、バーバー、ネイルサロン、ビューティーサロンの受付や待合スペースで、料金、施術例、キャンペーン、商品紹介などを表示できます。</p><h3>サービスと料金を分かりやすく</h3><p>カット、カラー、トリートメント、ネイル、フェイシャルなどのメニューや価格を画面で案内できます。</p><h3>施術例・ポートフォリオを表示</h3><p>ビフォーアフターやスタイル写真をローテーション表示できます。</p><img src="/assets/img/solution/digital_signage_in_barber_shop.jpeg" alt="美容室とバーバー向けデジタルサイネージ" style="width:100%; margin:20px 0;" /><h3>キャンペーンをすぐ更新</h3><p>季節限定メニュー、空き枠、セットプランなどをスマホから更新できます。</p><h3>スタッフや商品を紹介</h3><p>スタッフの得意分野、取扱商品、店販キャンペーン、レビューなども表示できます。</p>`
    }
  }
};

export function withJapaneseSolution(solution) {
  const ja = JAPANESE_SOLUTION_CONTENT[solution.id];
  if (!ja) return solution;
  const slug = typeof solution.slug === 'string'
    ? { en: solution.slug, ja: ja.slug }
    : { ...solution.slug, ja: ja.slug };
  return {
    ...solution,
    slug,
    translations: { ...solution.translations, ja: ja.translation },
  };
}
